import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/global-board/icons/timer-white.svg'
import _imports_1 from '@/assets/global-board/icons/money-white.svg'
import _imports_2 from '@/assets/global-board/icons/pin.svg'
import _imports_3 from '@/assets/global-board/icons/foward-arrow.svg'
import _imports_4 from '@/assets/global-board/icons/apply-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-3b6a814e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-col justify-center items-center h-full min-h-screen" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "w-full bg-background animate__animated animate__fadeIn animate__delay-0.4s min-h-screen" }
const _hoisted_5 = {
  key: 0,
  class: "w-full animate__animated animate__fadeIn animate__delay-0.4s"
}
const _hoisted_6 = { class: "flex flex-col w-full justify-center items-center mt-6" }
const _hoisted_7 = { class: "w-full lg:w-10/12 lg:p-6 lg:p-2 bg-white lg:rounded-2xl lg:shadow-2xl" }
const _hoisted_8 = { class: "w-full relative" }
const _hoisted_9 = { class: "flex flex-col justify-center items-center" }
const _hoisted_10 = { class: "flex flex-row space-x-1 justify-center items-center" }
const _hoisted_11 = { class: "h-24 w-24 lg:h-36 lg:w-36 rounded-lg relative z-50 bg-white shadow-card flex flex-col justify-center items-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "text-white lg:text-3xl xs:text-base sm:text-base md:text-2xl font-bold text-center mt-4" }
const _hoisted_14 = { class: "flex flex-col lg:flex-row lg:space-x-20 lg:text-base text-sm mt-6" }
const _hoisted_15 = { class: "flex flex-row text-white rounded-lg px-2 py-1 justify-center items-center capitalize" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-3 text-gray-300"
}, null, -1))
const _hoisted_17 = { class: "flex flex-row text-white rounded-lg px-2 py-1 justify-center items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-3 text-gray-300"
}, null, -1))
const _hoisted_19 = { class: "flex flex-row text-white rounded-lg px-2 py-1 justify-center items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mr-3 text-gray-300"
}, null, -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "flex flex-col mt-4 px-4 lg:px-0" }
const _hoisted_24 = { class: "flex flex-row justify-between items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-base lg:text-xl text-gray-600 font-semibold" }, "Description", -1))
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Share this job ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 ml-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
  })
], -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "flex flex-col justify-start items-start mt-4" }
const _hoisted_31 = { class: "lg:px-8 text-sm lg:text-base text-gray-600 text-justify" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex flex-col mt-12 text-sm font-medium" }, "Requirements", -1))
const _hoisted_33 = {
  key: 0,
  class: "list-disc px-4 lg:px-12 mt-2 lg:mt-8"
}
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex flex-col mt-4 lg:mt-12 text-sm font-medium" }, "Benefits", -1))
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-t-2 border-gray-300 mt-8 w-full" }, null, -1))
const _hoisted_38 = { class: "mt-4" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-base lg:text-xl text-gray-700" }, "Skills", -1))
const _hoisted_40 = { class: "flex flex-col mt-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm font-medium" }, "Required", -1))
const _hoisted_42 = { class: "flex flex-wrap" }
const _hoisted_43 = { class: "flex flex-col mt-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm font-medium" }, "Nice to have", -1))
const _hoisted_45 = { class: "flex flex-wrap" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-t-2 border-gray-300 mt-8 w-full" }, null, -1))
const _hoisted_47 = { class: "my-4" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-base lg:text-xl text-gray-700" }, "Location", -1))
const _hoisted_49 = { class: "mt-3 flex flex-row w-full px-5 space-x-1" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400" }, "Location", -1))
const _hoisted_51 = { class: "text-sm text-primary" }
const _hoisted_52 = { class: "w-full flex flex-col justify-end items-end mt-4 lg:mb-0 mb-4" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "mr-3 text-gray-300",
  width: ""
}, null, -1))
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Apply now ")
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = {
  key: 1,
  class: "animate__animated animate__fadeIn animate__delay-0.4s bg-gray-100"
}
const _hoisted_57 = { class: "flex flex-col justify-center items-center" }
const _hoisted_58 = { class: "w-full lg:rounded-2xl lg:mb-12" }
const _hoisted_59 = {
  key: 2,
  class: "animate__animated animate__fadeIn animate__delay-0.4s"
}
const _hoisted_60 = { class: "flex flex-col w-full justify-center items-center mt-6" }
const _hoisted_61 = { class: "w-full lg:w-10/12 lg:p-6 p-2 bg-white rounded-2xl shadow-card mb-12" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold" }, "Apply job", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-4 p-2" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "p-4 flex flex-row justify-between items-center w-full" }
const _hoisted_66 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ApplyJobForm = _resolveComponent("ApplyJobForm")!
  const _component_SuccessApply = _resolveComponent("SuccessApply")!
  const _component_PoweredByFooter = _resolveComponent("PoweredByFooter")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_ctx.isLoadingPage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Loader)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.stepApplication === 'jobInfo')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", {
                        class: "w-full hero-job flex flex-col justify-center items-center",
                        style: _normalizeStyle({
                  backgroundColor: _ctx.job.company?.company_branding?.primary_color,
                  backgroundImage: `url(${_ctx.job.company?.company_branding?.background?.url} )`,
                })
                      }, [
                        _createElementVNode("div", {
                          class: "w-full hero-job flex flex-col justify-center items-center",
                          style: _normalizeStyle({
                    backgroundColor: _ctx.job.company?.company_branding?.background
                      ?.url
                      ? _ctx.hexToRGBA(
                          _ctx.job.company?.company_branding?.primary_color,
                          0.2
                        )
                      : _ctx.job.company?.company_branding?.primary_color,
                  })
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                (_ctx.job.company?.company_branding?.logo?.url)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "object-cover bg-white rounded-lg w-full h-full small-hero",
                                      src: _ctx.job.company?.company_branding?.logo?.url
                                    }, null, 8, _hoisted_12))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.job.title), 1),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("span", _hoisted_15, [
                                _hoisted_16,
                                _createTextVNode(" " + _toDisplayString(_ctx.job.employment_type
                            ? String(_ctx.job.employment_type).replaceAll("_", " ")
                            : "No defined"), 1)
                              ]),
                              _createElementVNode("span", _hoisted_17, [
                                _hoisted_18,
                                _createTextVNode(" $" + _toDisplayString(_ctx.job.salary_min.annual
                            ? _ctx.numberWithCommas(_ctx.job.salary_min.annual)
                            : 0) + " - $" + _toDisplayString(_ctx.job.salary_max.annual
                            ? _ctx.numberWithCommas(_ctx.job.salary_max.annual)
                            : 0) + " " + _toDisplayString(_ctx.job.currency_salary) + " per year", 1)
                              ]),
                              _createElementVNode("span", _hoisted_19, [
                                _hoisted_20,
                                (_ctx.job.job_location)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.job.is_remote
                              ? "Remote"
                              : _ctx.job.job_location?.location?.city +
                                ", " +
                                _ctx.job.job_location?.location?.state +
                                ", " +
                                _ctx.job.job_location?.location?.country), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_22, "No defined"))
                              ])
                            ])
                          ])
                        ], 4)
                      ], 4)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", {
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shareJob && _ctx.shareJob(...args))),
                            class: "flex flex-row text-primary justify-center items-center font-medium hover:bg-primary-light py-1 px-3 rounded-lg cursor-pointer lg:text-base text-sm"
                          }, _hoisted_29)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.job.description ? _ctx.job.description : "No description added"), 1),
                        _hoisted_32,
                        (_ctx.job && _ctx.job.requirements !== '<li></li>')
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_33, [
                              _createElementVNode("li", {
                                class: "text-justify font-normal text-gray-600 text-sm lg:text-base py-2 leading-2",
                                innerHTML: _ctx.job.requirements
                              }, null, 8, _hoisted_34)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_35,
                        _createElementVNode("span", {
                          class: "py-2 px-6 text-sm lg:text-base",
                          innerHTML: _ctx.job.job_benefits
                        }, null, 8, _hoisted_36),
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredSkills, (item, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: index,
                                  class: "text-primary text-sm px-3 py-1 bg-primary-light rounded-lg m-1"
                                }, _toDisplayString(item), 1))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _hoisted_44,
                            _createElementVNode("div", _hoisted_45, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.niceToHaveSkills, (item, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: index,
                                  class: "text-primary text-sm px-3 py-1 bg-primary-light rounded-lg m-1"
                                }, _toDisplayString(item), 1))
                              }), 128))
                            ])
                          ])
                        ]),
                        _hoisted_46,
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.job.job_location?.location?.street_address), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.actionButton && _ctx.actionButton(...args))),
                            class: "flex flex-row bg-primary hover:bg-purple-700 text-white justify-center items-center lg:px-4 px-4 lg:py-3 py-2 rounded-3xl shadow-card lg:text-base text-xs"
                          }, _hoisted_55)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.stepApplication === 'jobForm')
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    (!_ctx.isLoadingPage)
                      ? (_openBlock(), _createBlock(_component_ApplyJobForm, {
                          key: 0,
                          job: _ctx.job,
                          onIsValidForm: _ctx.isValidForm,
                          onIsSavingJob: _ctx.isSavingJob,
                          onJobApplied: _ctx.jobApplied,
                          onJobInfo: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSteepApplication('jobInfo'))),
                          isClicked: _ctx.isClicked,
                          application: _ctx.careers
                        }, null, 8, ["job", "onIsValidForm", "onIsSavingJob", "onJobApplied", "isClicked", "application"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.stepApplication === 'jobSuccess')
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_SuccessApply)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_PoweredByFooter)
        ]),
        _createVNode(_component_base_modal, { visible: _ctx.showModal }, {
          title: _withCtx(() => [
            _hoisted_62
          ]),
          thumbnail: _withCtx(() => [
            _hoisted_63
          ]),
          "alert-text": _withCtx(() => [
            _createElementVNode("p", {
              class: "text-center text-lg",
              innerHTML: _ctx.modalText
            }, null, 8, _hoisted_64)
          ]),
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("button", {
                class: "btn-outline-sm flex flex-row items-center disabled:opacity-50 justify-between px-4 py-2 text-primary truncate sm:text-base border-2 rounded-full transition duration-150 ease-in",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(false)), ["prevent"]))
              }, " Cancel "),
              _createElementVNode("button", {
                disabled: _ctx.savingJob,
                class: "btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in disabled:cursor-not-allowed",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(true)), ["prevent"]))
              }, _toDisplayString(_ctx.modalButtonText), 9, _hoisted_66)
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
}